// extracted by mini-css-extract-plugin
export default {"testimonial":"SayAboutUs_testimonial__yDQLl","testimonial__img":"SayAboutUs_testimonial__img__r0rc-","testimonial__content":"SayAboutUs_testimonial__content__DX4yz"};